import React, { Component } from 'react';
import { Button, Checkbox, Divider, Dropdown, Grid, Modal, TextArea } from 'semantic-ui-react';
import { toast } from 'react-toastify';
import { isNullOrUndefined } from 'util';

import getFullNameOrUserName from '../../../utils/user';
import { insertErrorReport, updateErrorReport } from '../../../services/AdErrorReportService';
import './ErrorReportModal.css';

const priorities = [
  {
    key: 'High',
    text: 'High',
    value: 'High',
  },
  {
    key: 'Medium',
    text: 'Medium',
    value: 'Medium',
  },
  {
    key: 'Low',
    text: 'Low',
    value: 'Low',
  },
];
const teams = [
  {
    key: 'Account',
    text: 'Account',
    value: 'Account',
  },
  {
    key: 'Campaign',
    text: 'Campaign',
    value: 'Campaign',
  },
  {
    key: 'Creative',
    text: 'Creative',
    value: 'Creative',
  },
  {
    key: 'Product',
    text: 'Product',
    value: 'Product',
  },
  {
    key: 'Sales',
    text: 'Sales',
    value: 'Sales',
  },
];
class ErrorReportModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorReport: props.errorReport ? props.errorReport : {
        ad_id: props.ad.ad_id,
        is_external: false,
      },
      showForm: false,
      hasReport: props.errorReport !== undefined && props.errorReport !== null,
    };
  }
  onCloseForm = () => {
    this.setState({
      showForm: false,
    });
  }
  getQCApproved = () => {
    const { ad } = this.props;
    let qcUsers = '';
    if (ad.adQc) {
      if (ad.adQc.qc1) {
        qcUsers = ad.adQc.qc1Fullname === '' ? ad.adQc.qc1Username : ad.adQc.qc1Fullname;
      }
      if (ad.adQc.qc2) {
        qcUsers = `${qcUsers}, ${ad.adQc.qc2Fullname === '' ? ad.adQc.qc2Username : ad.adQc.qc2Fullname}`;
      }
    }
    return qcUsers === '' ? 'NONE' : qcUsers;
  }
  getLoggedBy = () => {
    const { errorReport, hasReport } = this.state;
    const currentUser = this.props.user;
    if (hasReport) {
      return (errorReport.logged_by_fullname && errorReport.logged_by_fullname !== '') ? errorReport.logged_by_fullname : errorReport.logged_by_username;
    } else if (currentUser) {
      return getFullNameOrUserName(currentUser);
    }
    return '';
  }
  processSave = async () => {
    const { hasReport, errorReport } = this.state;
    const { user, ad, month, year } = this.props;
    const fullname = getFullNameOrUserName(user);
    const email = user.email;
    if (hasReport) {
      const reportFields = [email, fullname, errorReport.is_external, errorReport.issue, errorReport.reason, errorReport.suggested_changes, errorReport.outcome, errorReport.team_responsible, errorReport.severity, ad.ad_id];
      const result = await updateErrorReport(reportFields);
      return result;
    }
    const reportFields = [ad.ad_id, email, fullname, errorReport.is_external, errorReport.issue, errorReport.reason, errorReport.suggested_changes, errorReport.outcome, errorReport.team_responsible, errorReport.severity, month, year, ad.account_id];
    const result = await insertErrorReport(reportFields);
    return result;
  }
  saveReport = () => {
    this.processSave().then((result) => {
      toast('Error Report Generated Successfully!', {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 2000,
        type: toast.TYPE.SUCCESS,
        hideProgressBar: true,
      });
      this.setState({
        hasReport: true,
        errorReport: result.report,
        showForm: false,
      });
      if (this.props.updateErrorAd) {
        const newStateAd = {
          ...this.props.ad,
          adReport: result.report,
        };
        this.props.updateErrorAd(newStateAd);
      }
    });
  }
  handleFieldUpdate = (fieldName, value) => {
    const { errorReport } = this.state;

    this.setState({
      errorReport: {
        ...errorReport,
        [fieldName]: value,
      },
    });
  }
  reportValid = () => {
    const { errorReport } = this.state;
    return isNullOrUndefined(errorReport.issue) ||
    isNullOrUndefined(errorReport.reason) ||
    isNullOrUndefined(errorReport.suggested_changes) ||
    isNullOrUndefined(errorReport.team_responsible) ||
    isNullOrUndefined(errorReport.severity);
  }
  render() {
    const { errorReport } = this.state;
    return (
      <div>
        <Button icon="bug" onClick={() => { this.setState({ showForm: true }); }} color="yellow" />
        <Modal
          dimmer="inverted"
          open={this.state.showForm}
          onClose={this.onCloseForm}
        >
          <Modal.Header>Error Report</Modal.Header>
          <Modal.Content>
            <Grid>
              <Grid.Row>
                <Grid.Column width={4}>
                  <Checkbox
                    toggle
                    onChange={() => { this.handleFieldUpdate('is_external', !errorReport.is_external); }}
                    checked={errorReport.is_external}
                  /><strong> External</strong>
                </Grid.Column>
                <Grid.Column width={4}>
                  <strong>Logged By </strong>
                  <div>{this.getLoggedBy()}</div>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={4}>
                  <strong>QC Approved By</strong>
                  <div>{this.getQCApproved()}</div>
                </Grid.Column>
                <Grid.Column width={4}>
                  <strong>Team Responsible</strong>
                  <Dropdown
                    placeholder="Team Responsible"
                    selection
                    options={teams}
                    onChange={(event, data) => { this.handleFieldUpdate('team_responsible', data.value); }}
                    value={errorReport.team_responsible}
                  />
                </Grid.Column>
                <Grid.Column width={4}>
                  <strong>Severity</strong>
                  <Dropdown
                    placeholder="Priority"
                    selection
                    options={priorities}
                    onChange={(event, data) => { this.handleFieldUpdate('severity', data.value); }}
                    value={errorReport.severity}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
            <Divider />
            <Grid>
              <Grid.Row>
                <Grid.Column>
                  <strong>Issue</strong>
                  <TextArea
                    placeholder="Issue"
                    onChange={(event, data) => { this.handleFieldUpdate('issue', data.value); }}
                    value={errorReport.issue}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <strong>Reason</strong>
                  <TextArea
                    placeholder="Reason"
                    onChange={(event, data) => { this.handleFieldUpdate('reason', data.value); }}
                    value={errorReport.reason}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <strong>Suggested Changes</strong>
                  <TextArea
                    placeholder="Suggested Changes"
                    onChange={(event, data) => { this.handleFieldUpdate('suggested_changes', data.value); }}
                    value={errorReport.suggested_changes}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <strong>Outcome</strong>
                  <TextArea
                    placeholder="Outcome"
                    onChange={(event, data) => { this.handleFieldUpdate('outcome', data.value); }}
                    value={errorReport.outcome}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <Button disabled={this.reportValid()} color="red" onClick={this.saveReport}>Report</Button>
                  <Button onClick={this.onCloseForm}>Cancel</Button>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Modal.Content>
        </Modal>
      </div>
    );
  }
}

export default ErrorReportModal;



// WEBPACK FOOTER //
// ./src/screens/Presentation/PresentationComponents/ErrorReportModal.js